/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import Logo from "../Assets/Logo.svg";
import { BsCart2 } from "react-icons/bs";
import { HiOutlineBars3 } from "react-icons/hi2";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import InfoIcon from "@mui/icons-material/Info";
import CommentRoundedIcon from "@mui/icons-material/CommentRounded";
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import ShoppingCartRoundedIcon from "@mui/icons-material/ShoppingCartRounded";
import { navigation_constants } from "../constants/navigation.constants";
import { Link, useNavigate } from "react-router-dom";

const Navbar = () => {
	const [openMenu, setOpenMenu] = useState(false);
	const navigate = useNavigate()

	const menuOptions = [
		{
			text: "Home",
			icon: <HomeIcon />,
		},
		{
			text: "About",
			icon: <InfoIcon />,
		},
		{
			text: "Testimonials",
			icon: <CommentRoundedIcon />,
		},
		{
			text: "Contact",
			icon: <PhoneRoundedIcon />,
		},
		{
			text: "Cart",
			icon: <ShoppingCartRoundedIcon />,
		},
	];
	return (
		<nav>
			<div className="nav-logo-container">
				<h2>S E C R E T S</h2>
			</div>
			<div className="navbar-links-container">
				<a href="">Home</a>
				<a href="">About</a>
				<Link to={navigation_constants.pages.privacy_policy}>Privacy Policy</Link>
				<Link to={navigation_constants.pages.tos}>Terms of Service</Link>
				{/* <a href="">
					<BsCart2 className="navbar-cart-icon" />
				</a> */}
				<button onClick={()=> navigate(navigation_constants.pages.join_beta)} className="primary-button">Join Closed Beta</button>
			</div>
			<div className="navbar-menu-container">
				<HiOutlineBars3 onClick={() => setOpenMenu(true)} />
			</div>
			{/* <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="right">
				<Box
					sx={{ width: 250 }}
					role="presentation"
					onClick={() => setOpenMenu(false)}
					onKeyDown={() => setOpenMenu(false)}
				>
					<List>
						{menuOptions.map((item) => (
							<ListItem key={item.text} disablePadding>
								<ListItemButton>
									<ListItemIcon>{item.icon}</ListItemIcon>
									<ListItemText primary={item.text} />
								</ListItemButton>
							</ListItem>
						))}
					</List>
					<Divider />
				</Box>
			</Drawer> */}
		</nav>
	);
};

export default Navbar;
